import { useCallback, type Dispatch, type SetStateAction } from 'react'
import { useLocalStorage } from './useLocalStorage'

const SHARED_SIDEBAR_STATE_KEY = 'shared-sidebar-open'

export function useSharedSidebarState(defaultValue = true) {
  const [sidebarOpen, setStoredSidebarOpen] = useLocalStorage<boolean>(SHARED_SIDEBAR_STATE_KEY, defaultValue)

  const setSidebarOpen = useCallback<Dispatch<SetStateAction<boolean>>>(
    (value) => {
      const nextValue = typeof value === 'function' ? value(sidebarOpen) : value
      setStoredSidebarOpen(nextValue)
    },
    [setStoredSidebarOpen, sidebarOpen]
  )

  return [sidebarOpen, setSidebarOpen] as const
}
